import CrehanaIso from '@crehana/icons/logos/CrehanaIso';
// biome-ignore lint/style/noRestrictedImports: legacy import, will be migrated
import { colors } from '@crehana/ui';

const CrehanaLogos = () => (
  <>
    <CrehanaIso className="sm:hidden" color={colors.white} size={20} />
    <CrehanaIso
      className="hidden sm:block lg:hidden"
      color={colors.white}
      size={28}
    />
    <CrehanaIso className="hidden lg:block" color={colors.white} size={34} />
  </>
);

export default CrehanaLogos;
